import { C as CosmosBadge$1, d as defineCustomElement$1 } from './p-Dg3cLMCn.js';

const CosmosBadge = CosmosBadge$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosBadge, defineCustomElement };
